var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.164,
    height: 20.164,
    viewBox: "0 0 20.164 20.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "print") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00a0e9",
    d: "M17.644,7.562V3.042a1.261,1.261,0,0,0-.369-.891L15.492.369A1.26,1.26,0,0,0,14.6,0H3.781a1.26,1.26,0,0,0-1.26,1.26v6.3A2.52,2.52,0,0,0,0,10.082v4.411a.63.63,0,0,0,.63.63h1.89V18.9a1.26,1.26,0,0,0,1.26,1.26h12.6a1.26,1.26,0,0,0,1.26-1.26V15.123h1.89a.63.63,0,0,0,.63-.63V10.082A2.52,2.52,0,0,0,17.644,7.562ZM15.123,17.644H5.041V13.863H15.123Zm0-8.822H5.041v-6.3H12.6v1.89a.63.63,0,0,0,.63.63h1.89Zm1.89,2.836a.945.945,0,1,1,.945-.945A.945.945,0,0,1,17.013,11.657Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.58d5ea2494381f1599bf05b321a24653.svg";
export { ForwardRef as ReactComponent };